module.exports = __webpack_public_path__ + "img/denver.c76ee39e.png";